export const templateMadeItForRecipe = String.raw`<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>Made it — Cacio e Pepe — Nemonto</title>
<link rel="preconnect" href="https://fonts.googleapis.com">
<link href="https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:ital,wght@0,400;0,500;0,600;0,700;1,400&display=swap" rel="stylesheet">
<style>
  :root{
    --spice:#D85A30; --spice-deep:#B23D18; --cream:#FAECE7; --peach:#F5C4B3;
    --charcoal:#2C2C2A; --herb:#1D9E75; --gold:#FAC775; --muted:#8A7A72;
    --serif:'DM Serif Display', Georgia, serif; --sans:'DM Sans', system-ui, sans-serif;
  }
  *{margin:0;padding:0;box-sizing:border-box;}
  body{background:#F1E4DE; color:var(--charcoal); font-family:var(--sans); font-size:14px; height:100vh; overflow:hidden;}
  a{color:inherit; text-decoration:none;}
  button{font-family:inherit; cursor:pointer; border:none; background:none;}
  :focus-visible{outline:2.5px solid var(--spice); outline-offset:2px; border-radius:4px;}
  ::-webkit-scrollbar{width:7px;}
  ::-webkit-scrollbar-thumb{background:rgba(44,44,42,0.14); border-radius:10px;}
  ::-webkit-scrollbar-track{background:transparent;}

  .app{display:grid; grid-template-columns:264px minmax(0,1fr) 300px; height:100vh; width:100%; max-width:none; margin:0;}

  /* ============ LEFT SIDEBAR ============ */
  .sidebar{padding:26px 18px; display:flex; flex-direction:column; height:100vh; border-right:1px solid rgba(44,44,42,0.07);}
  .brand{display:flex; align-items:center; gap:9px; font-family:var(--serif); font-size:21px; padding:0 10px 28px;}
  .nav-item{display:flex; align-items:center; gap:13px; padding:11px 12px; border-radius:14px; width:100%; font-size:15px; font-weight:500; color:#6B5F58; transition:background .15s, color .15s;}
  .nav-item:hover{background:rgba(44,44,42,0.04);}
  .nav-item.active{background:var(--spice); color:var(--cream);}
  .nav-icon{width:21px; height:21px; flex-shrink:0; display:flex; align-items:center; justify-content:center;}
  .nav-badge{margin-left:auto; background:var(--gold); color:#5A3A00; font-size:10.5px; font-weight:700; padding:2px 7px; border-radius:20px;}
  .nav-item.active .nav-badge{background:rgba(250,236,231,0.25); color:var(--cream);}
  .post-btn{margin:18px 10px 22px; background:var(--spice); color:var(--cream); padding:13px; border-radius:16px; font-size:14.5px; font-weight:700; display:flex; align-items:center; justify-content:center; gap:8px; transition:transform .15s, box-shadow .15s;}
  .post-btn:hover{transform:translateY(-1px); box-shadow:0 10px 22px rgba(216,90,48,0.3);}
  .sidebar-spacer{flex:1;}
  .profile-mini{display:flex; align-items:center; gap:10px; padding:9px 10px; border-radius:14px;}
  .pm-avatar{width:38px; height:38px; border-radius:50%; background:#9FE1CB; flex-shrink:0;}
  .pm-name{font-size:13.5px; font-weight:600;}
  .pm-handle{font-size:11.5px; color:#9A8C84;}
  .pm-more{margin-left:auto; color:#9A8C84;}

  /* ============ CENTER ============ */
  .main-col{height:100vh; overflow-y:auto; border-right:1px solid rgba(44,44,42,0.07);}

  .page-header{
    position:sticky; top:0; z-index:5; background:rgba(241,228,222,0.94); backdrop-filter:blur(8px);
    padding:18px 28px 0; border-bottom:1px solid rgba(44,44,42,0.06);
  }
  .back-row{display:flex; align-items:center; gap:10px; font-size:13px; color:#9A8C84; font-weight:600; margin-bottom:14px;}

  /* pinned recipe card */
  .recipe-pin{
    display:flex; align-items:center; gap:13px; background:#fff; border-radius:18px; padding:13px 16px; margin-bottom:14px;
    border:1px solid rgba(44,44,42,0.06);
  }
  .rp-thumb{width:54px; height:54px; border-radius:13px; flex-shrink:0; display:flex; align-items:center; justify-content:center;}
  .rp-info{flex:1; min-width:0;}
  .rp-label{font-size:10.5px; color:#9A8C84; margin-bottom:2px;}
  .rp-title{font-family:var(--serif); font-size:16px; line-height:1.2; margin-bottom:3px;}
  .rp-by{font-size:11.5px; color:#9A8C84;}
  .rp-by b{color:var(--spice-deep);}
  .rp-view-btn{font-size:12px; font-weight:700; color:var(--spice-deep); padding:8px 14px; border-radius:20px; border:1px solid rgba(216,90,48,0.25); flex-shrink:0; white-space:nowrap;}

  .ph-title{font-family:var(--serif); font-size:22px; margin-bottom:14px;}

  .filter-row{display:flex; gap:7px; padding-bottom:16px; flex-wrap:wrap;}
  .filter-pill{font-size:12px; font-weight:600; padding:7px 13px; border-radius:20px; background:#fff; border:1px solid rgba(44,44,42,0.1); color:#6B5F58;}
  .filter-pill.active{background:var(--spice); color:#fff; border-color:var(--spice);}

  .sort-row{display:flex; align-items:center; gap:8px; margin-left:auto;}
  .sort-select{font-size:12px; color:#6B5F58; background:#fff; border:1px solid rgba(44,44,42,0.1); border-radius:20px; padding:7px 12px;}

  .body-wrap{padding:18px 28px 60px; max-width:none;}

  /* made-it entry card */
  .entry-card{background:#fff; border-radius:20px; padding:16px; margin-bottom:16px; border:1px solid rgba(44,44,42,0.06);}
  .entry-card.is-winner{border:2px solid var(--gold); background:rgba(250,199,117,0.05);}

  .winner-flag{
    display:flex; align-items:center; gap:7px; background:rgba(250,199,117,0.2); color:#8A5A00; font-size:11.5px;
    font-weight:700; padding:7px 13px; border-radius:20px; margin-bottom:12px;
  }

  .ec-top{display:flex; align-items:center; gap:10px; margin-bottom:11px;}
  .ec-avatar{width:38px; height:38px; border-radius:50%; flex-shrink:0;}
  .ec-name{font-size:13.5px; font-weight:600; display:flex; align-items:center; gap:5px;}
  .ec-time{font-size:11.5px; color:#9A8C84;}
  .ec-reaction{margin-left:auto; font-size:10.5px; font-weight:700; padding:4px 10px; border-radius:20px;}
  .ec-reaction.nailed{background:#E1F5EE; color:#085041;}
  .ec-reaction.twist{background:#FAEEDA; color:#633806;}
  .ec-reaction.almost{background:#F1E4DE; color:#6B5F58;}
  .ec-reaction.tips{background:#EEEDFE; color:#3C3489;}

  .ec-media{height:180px; border-radius:14px; margin-bottom:11px; display:flex; align-items:center; justify-content:center; position:relative;}
  .ec-play{position:absolute; bottom:10px; right:10px; width:34px; height:34px; border-radius:50%; background:rgba(255,255,255,0.92); display:flex; align-items:center; justify-content:center; color:var(--spice-deep);}

  .ec-text{font-size:13.5px; color:#3A3330; line-height:1.55; margin-bottom:12px;}
  .ec-cook-time{display:inline-flex; align-items:center; gap:5px; font-size:11.5px; color:#9A8C84; background:#F8EFEB; padding:4px 10px; border-radius:20px; margin-bottom:12px;}

  .ec-actions{display:flex; align-items:center; gap:18px; padding-top:11px; border-top:1px solid rgba(44,44,42,0.06);}
  .ec-action{display:flex; align-items:center; gap:6px; font-size:12.5px; color:#6B5F58; font-weight:500; cursor:pointer;}
  .ec-action.liked{color:var(--spice-deep);}
  .ec-share{margin-left:auto;}

  /* ============ RIGHT RAIL ============ */
  .right-rail{height:100vh; overflow-y:auto; padding:24px 20px 40px;}
  .rail-block{margin-bottom:26px;}
  .rail-head{margin-bottom:14px;}
  .rail-head h3{font-size:13px; font-weight:700; text-transform:uppercase; letter-spacing:0.04em; color:#6B5F58;}

  .recipe-summary-card{background:var(--charcoal); border-radius:18px; padding:20px; position:relative; overflow:hidden;}
  .recipe-summary-card::before{content:''; position:absolute; top:-50px; right:-40px; width:130px; height:130px; background:radial-gradient(circle, rgba(216,90,48,0.4), transparent 70%);}
  .rs-title{font-family:var(--serif); font-size:16px; color:var(--cream); margin-bottom:14px; position:relative; line-height:1.3;}
  .rs-stats{display:grid; grid-template-columns:1fr 1fr; gap:8px; position:relative;}
  .rs-stat{background:rgba(250,236,231,0.07); border-radius:11px; padding:10px; text-align:center;}
  .rs-stat b{display:block; font-size:17px; color:var(--gold); font-family:var(--serif);}
  .rs-stat span{font-size:9.5px; color:rgba(250,236,231,0.55);}

  .reaction-breakdown{background:#fff; border-radius:16px; padding:16px; border:1px solid rgba(44,44,42,0.06);}
  .rb-row{display:flex; align-items:center; gap:10px; margin-bottom:10px;}
  .rb-row:last-child{margin-bottom:0;}
  .rb-label{font-size:12px; color:#6B5F58; width:84px; flex-shrink:0;}
  .rb-bar-wrap{flex:1; height:8px; background:rgba(44,44,42,0.06); border-radius:4px; overflow:hidden;}
  .rb-bar{height:100%; border-radius:4px;}
  .rb-count{font-size:12px; font-weight:600; color:var(--charcoal); width:24px; text-align:right;}

  .creator-card{background:#fff; border-radius:16px; padding:16px; border:1px solid rgba(44,44,42,0.06); text-align:center;}
  .cc-avatar{width:54px; height:54px; border-radius:50%; margin:0 auto 10px; position:relative;}
  .cc-ring{position:absolute; inset:-3px; border-radius:50%; border:2px solid var(--gold);}
  .cc-name{font-size:14px; font-weight:600; margin-bottom:2px;}
  .cc-handle{font-size:11.5px; color:#9A8C84; margin-bottom:12px;}
  .cc-follow{width:100%; background:var(--spice); color:#fff; font-size:12.5px; font-weight:700; padding:9px 0; border-radius:14px;}
  .cc-follow.following{background:#fff; border:1.5px solid rgba(44,44,42,0.14); color:var(--charcoal);}

  .cook-time-chart{background:#fff; border-radius:16px; padding:16px; border:1px solid rgba(44,44,42,0.06);}
  .ctc-row{display:flex; align-items:center; gap:9px; margin-bottom:9px;}
  .ctc-row:last-child{margin-bottom:0;}
  .ctc-label{font-size:11.5px; color:#6B5F58; width:62px; flex-shrink:0;}
  .ctc-bar-wrap{flex:1; height:8px; background:rgba(44,44,42,0.06); border-radius:4px; overflow:hidden;}
  .ctc-bar{height:100%; border-radius:4px; background:var(--spice);}
  .ctc-count{font-size:11px; color:#9A8C84; width:30px; text-align:right;}

  @media (max-width:1180px){
    .app{grid-template-columns:84px minmax(0,1fr) 300px;}
    .brand span.brand-text, .nav-item span.nav-label, .post-btn span.btn-label, .pm-name, .pm-handle{display:none;}
    .nav-item{justify-content:center;} .nav-badge{display:none;} .post-btn{padding:13px;} .profile-mini{justify-content:center;}
  }
  @media (max-width:900px){
    .app{grid-template-columns:84px minmax(0,1fr);}
    .right-rail{display:none;}
  }
</style>
</head>
<body>

<div class="app">

  <!-- ================= LEFT SIDEBAR ================= -->
  <aside class="sidebar">
    <div class="brand">
      <img src="../image/nemonto-logo.png" alt="Nemonto" style="height:32px; width:auto; display:block;" />
    </div>
    <nav>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M4 11l8-7 8 7M6 10v9a1 1 0 001 1h4v-6h2v6h4a1 1 0 001-1v-9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Home</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="1.8"/><path d="M20 20l-3.5-3.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></span>
        <span class="nav-label">Explore</span>
      </a>
      <a class="nav-item active" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M4 4h16v12H7l-3 3V4z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Made it</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M4 21V5a1 1 0 011-1h14a1 1 0 011 1v16l-8-4-8 4z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Challenges</span>
        <span class="nav-badge">3 live</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M20.8 4.6c-1.5-1.5-4-1.5-5.6.1L12 7.9 8.8 4.7c-1.6-1.6-4.1-1.6-5.6-.1-1.5 1.5-1.5 4 .1 5.6L12 19l8.7-8.8c1.6-1.6 1.6-4.1.1-5.6z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Saved</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M21 11.5a8.4 8.4 0 01-1.2 4.4L21 20l-4.3-1.2a8.5 8.5 0 11-1.8-15.6 8.5 8.5 0 016.1 7.3z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Messages</span>
        <span class="nav-badge">2</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="9" cy="8" r="3.4" stroke="currentColor" stroke-width="1.6"/><path d="M3 19c0-3 2.5-5 6-5s6 2 6 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg></span>
        <span class="nav-label">Profile</span>
      </a>
    </nav>
    <div class="post-btn">
      <svg width="17" height="17" viewBox="0 0 20 20" fill="none"><path d="M10 4v12M4 10h12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
      <span class="btn-label">New recipe</span>
    </div>
    <div class="sidebar-spacer"></div>
    <div class="profile-mini">
      <div class="pm-avatar"></div>
      <div><div class="pm-name">Priya Rajan</div><div class="pm-handle">@priyacooks</div></div>
      <span class="pm-more">⋯</span>
    </div>
  </aside>

  <!-- ================= CENTER ================= -->
  <main class="main-col">

    <div class="page-header">
      <div class="back-row">
        <svg width="16" height="16" viewBox="0 0 16 16"><path d="M10 13L5 8l5-5" stroke="#9A8C84" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
        Back to recipe
      </div>

      <div class="recipe-pin">
        <div class="rp-thumb" style="background:linear-gradient(150deg,#E8916F,#B23D18);">
          <svg width="28" height="28" viewBox="0 0 100 100"><path d="M18 50 Q18 80 50 80 Q82 80 82 50 Z" fill="#fff" opacity="0.9"/></svg>
        </div>
        <div class="rp-info">
          <div class="rp-label">Viewing made-its for</div>
          <p class="rp-title">Cacio e Pepe — nonna's version</p>
          <p class="rp-by">by <b>Maria K.</b> 🏅 · Italian · 15 min</p>
        </div>
        <a href="#" class="rp-view-btn">View recipe</a>
      </div>

      <p class="ph-title">47 people made it</p>

      <div class="filter-row">
        <span class="filter-pill active" data-filter="all">All · 47</span>
        <span class="filter-pill" data-filter="nailed">🔥 Nailed it · 31</span>
        <span class="filter-pill" data-filter="twist">🔄 My twist · 9</span>
        <span class="filter-pill" data-filter="almost">😅 Almost · 7</span>
        <div class="sort-row">
          <select class="sort-select" id="sortSelect">
            <option>Most recent</option>
            <option>Most liked</option>
            <option>Fastest cook time</option>
          </select>
        </div>
      </div>
    </div>

    <div class="body-wrap" id="entriesBody">

      <!-- ENTRY 1 -->
      <div class="entry-card is-winner" data-reaction="nailed" data-likes="241" data-cooktime="12">
        <div class="winner-flag">🏆 Challenge winner — chosen by Maria</div>
        <div class="ec-top">
          <div class="ec-avatar" style="background:#9FE1CB;"></div>
          <div><div class="ec-name">Priya R. 🏅</div><div class="ec-time">2 hours ago</div></div>
          <span class="ec-reaction nailed">🔥 Nailed it</span>
        </div>
        <div class="ec-media" style="background:linear-gradient(150deg,#6FCBA4,#0D6B4E);">
          <svg width="38" height="38" viewBox="0 0 100 100"><circle cx="38" cy="44" r="10" fill="#fff" opacity="0.9"/><circle cx="58" cy="40" r="8" fill="#fff" opacity="0.7"/></svg>
          <div class="ec-play"><svg width="14" height="14" viewBox="0 0 16 16"><path d="M4 2l10 6-10 6V2z" fill="currentColor"/></svg></div>
        </div>
        <span class="ec-cook-time">⏱ 12 min</span>
        <p class="ec-text">Used the pasta water trick exactly like you said — went from grainy to silky the second time around.</p>
        <div class="ec-actions">
          <span class="ec-action liked">♥ 241</span>
          <span class="ec-action">💬 18</span>
          <span class="ec-action ec-share">↗ Share</span>
        </div>
      </div>

      <!-- ENTRY 2 -->
      <div class="entry-card" data-reaction="twist" data-likes="87" data-cooktime="18">
        <div class="ec-top">
          <div class="ec-avatar" style="background:#AFA9EC;"></div>
          <div><div class="ec-name">James L.</div><div class="ec-time">4 hours ago</div></div>
          <span class="ec-reaction twist">🔄 My twist</span>
        </div>
        <div class="ec-media" style="background:linear-gradient(150deg,#9890DF,#534AB7);">
          <svg width="38" height="38" viewBox="0 0 100 100"><rect x="22" y="34" width="56" height="42" rx="8" fill="#fff" opacity="0.6"/></svg>
          <div class="ec-play"><svg width="14" height="14" viewBox="0 0 16 16"><path d="M4 2l10 6-10 6V2z" fill="currentColor"/></svg></div>
        </div>
        <span class="ec-cook-time">⏱ 18 min</span>
        <p class="ec-text">Added a little lemon zest at the end — cuts through the richness nicely. Still very much your recipe though.</p>
        <div class="ec-actions">
          <span class="ec-action">♥ 87</span>
          <span class="ec-action">💬 9</span>
          <span class="ec-action ec-share">↗ Share</span>
        </div>
      </div>

      <!-- ENTRY 3 -->
      <div class="entry-card" data-reaction="nailed" data-likes="64" data-cooktime="15">
        <div class="ec-top">
          <div class="ec-avatar" style="background:#F5C4B3;"></div>
          <div><div class="ec-name">Chen W.</div><div class="ec-time">6 hours ago</div></div>
          <span class="ec-reaction nailed">🔥 Nailed it</span>
        </div>
        <div class="ec-media" style="background:linear-gradient(150deg,#E8693D,#993C1D);">
          <svg width="38" height="38" viewBox="0 0 100 100"><circle cx="50" cy="50" r="22" fill="#fff" opacity="0.6"/></svg>
          <div class="ec-play"><svg width="14" height="14" viewBox="0 0 16 16"><path d="M4 2l10 6-10 6V2z" fill="currentColor"/></svg></div>
        </div>
        <span class="ec-cook-time">⏱ 15 min</span>
        <p class="ec-text">Didn't expect 3 ingredients to taste this good. My kitchen smells like a trattoria right now.</p>
        <div class="ec-actions">
          <span class="ec-action">♥ 64</span>
          <span class="ec-action">💬 5</span>
          <span class="ec-action ec-share">↗ Share</span>
        </div>
      </div>

      <!-- ENTRY 4 -->
      <div class="entry-card" data-reaction="almost" data-likes="19" data-cooktime="22">
        <div class="ec-top">
          <div class="ec-avatar" style="background:#FAC775;"></div>
          <div><div class="ec-name">Sofia M. 🏅</div><div class="ec-time">Yesterday</div></div>
          <span class="ec-reaction almost">😅 Almost</span>
        </div>
        <span class="ec-cook-time">⏱ 22 min</span>
        <p class="ec-text">First attempt clumped on me but I think I added the cheese too fast. Trying again tomorrow with the slow whisk tip.</p>
        <div class="ec-actions">
          <span class="ec-action">♥ 19</span>
          <span class="ec-action">💬 3</span>
          <span class="ec-action ec-share">↗ Share</span>
        </div>
      </div>

      <!-- ENTRY 5 -->
      <div class="entry-card" data-reaction="nailed" data-likes="33" data-cooktime="11">
        <div class="ec-top">
          <div class="ec-avatar" style="background:#9890DF;"></div>
          <div><div class="ec-name">Tom R.</div><div class="ec-time">2 days ago</div></div>
          <span class="ec-reaction nailed">🔥 Nailed it</span>
        </div>
        <span class="ec-cook-time">⏱ 11 min</span>
        <p class="ec-text">Fastest weeknight pasta I've ever made that didn't taste like a shortcut.</p>
        <div class="ec-actions">
          <span class="ec-action">♥ 33</span>
          <span class="ec-action">💬 2</span>
          <span class="ec-action ec-share">↗ Share</span>
        </div>
      </div>

    </div>
  </main>

  <!-- ================= RIGHT RAIL ================= -->
  <aside class="right-rail">

    <div class="rail-block">
      <div class="recipe-summary-card">
        <p class="rs-title">Cacio e Pepe — nonna's version</p>
        <div class="rs-stats">
          <div class="rs-stat"><b>47</b><span>made it</span></div>
          <div class="rs-stat"><b>15 min</b><span>avg cook time</span></div>
          <div class="rs-stat"><b>142</b><span>likes on original</span></div>
          <div class="rs-stat"><b>1</b><span>challenge win</span></div>
        </div>
      </div>
    </div>

    <div class="rail-block">
      <div class="rail-head"><h3>Reaction breakdown</h3></div>
      <div class="reaction-breakdown">
        <div class="rb-row">
          <span class="rb-label">🔥 Nailed it</span>
          <div class="rb-bar-wrap"><div class="rb-bar" style="width:66%; background:#1D9E75;"></div></div>
          <span class="rb-count">31</span>
        </div>
        <div class="rb-row">
          <span class="rb-label">🔄 My twist</span>
          <div class="rb-bar-wrap"><div class="rb-bar" style="width:19%; background:#EF9F27;"></div></div>
          <span class="rb-count">9</span>
        </div>
        <div class="rb-row">
          <span class="rb-label">😅 Almost</span>
          <div class="rb-bar-wrap"><div class="rb-bar" style="width:15%; background:#9A8C84;"></div></div>
          <span class="rb-count">7</span>
        </div>
      </div>
    </div>

    <div class="rail-block">
      <div class="rail-head"><h3>Cook times reported</h3></div>
      <div class="cook-time-chart">
        <div class="ctc-row"><span class="ctc-label">Under 12m</span><div class="ctc-bar-wrap"><div class="ctc-bar" style="width:38%;"></div></div><span class="ctc-count">18</span></div>
        <div class="ctc-row"><span class="ctc-label">12–18m</span><div class="ctc-bar-wrap"><div class="ctc-bar" style="width:51%;"></div></div><span class="ctc-count">24</span></div>
        <div class="ctc-row"><span class="ctc-label">Over 18m</span><div class="ctc-bar-wrap"><div class="ctc-bar" style="width:11%;"></div></div><span class="ctc-count">5</span></div>
      </div>
    </div>

    <div class="rail-block">
      <div class="rail-head"><h3>Recipe by</h3></div>
      <div class="creator-card">
        <div class="cc-avatar" style="background:#F0997B;"><div class="cc-ring"></div></div>
        <p class="cc-name">Maria K.</p>
        <p class="cc-handle">@mariakcooks · 8.2k followers</p>
        <button class="cc-follow" id="creatorFollowBtn">Follow Maria</button>
      </div>
    </div>

  </aside>

</div>

<script>
  document.querySelectorAll('.filter-pill').forEach(pill => {
    pill.addEventListener('click', () => {
      document.querySelectorAll('.filter-pill').forEach(p => p.classList.remove('active'));
      pill.classList.add('active');
      const filter = pill.dataset.filter;
      document.querySelectorAll('.entry-card').forEach(card => {
        card.style.display = (filter === 'all' || card.dataset.reaction === filter) ? 'block' : 'none';
      });
    });
  });

  document.getElementById('sortSelect').addEventListener('change', (e) => {
    const sortBy = e.target.value;
    const body = document.getElementById('entriesBody');
    const cards = [...body.querySelectorAll('.entry-card')];
    cards.sort((a, b) => {
      if(sortBy === 'Most liked') return parseInt(b.dataset.likes) - parseInt(a.dataset.likes);
      if(sortBy === 'Fastest cook time') return parseInt(a.dataset.cooktime) - parseInt(b.dataset.cooktime);
      return 0;
    });
    cards.forEach(card => body.appendChild(card));
  });

  document.querySelectorAll('.ec-action').forEach(btn => {
    if(btn.textContent.trim().startsWith('♥') || btn.textContent.trim().startsWith('♡')){
      btn.addEventListener('click', () => btn.classList.toggle('liked'));
    }
  });

  const creatorFollowBtn = document.getElementById('creatorFollowBtn');
  creatorFollowBtn.addEventListener('click', () => {
    const following = creatorFollowBtn.classList.toggle('following');
    creatorFollowBtn.textContent = following ? 'Following' : 'Follow Maria';
  });
</script>

</body>
</html>

`;
